let variantDataItem =
  document.querySelector('[data-content="variants-json"]') || null;

let currentOfferData;
offer = null;

if (variantDataItem !== null) {
  const currentUrl = new URL(window.location.href);
  let changeDefaultSelection = false;
  if (!currentUrl.searchParams.get('variant')) {
    if (document.querySelectorAll('label.bag-qty--option').length > 2) {
      changeDefaultSelection = true;
    }
  }
  const variantData = JSON.parse(variantDataItem.value);
  const nutritionJson = document.querySelector(
    '[data-content="variants-nutrition-json"]'
  );
  const variantNutrition = nutritionJson
    ? JSON.parse(nutritionJson.value)
    : null;
  const priceScale = {
    1: 1,
    2: 0.85,
    3: 0.8
  };

  const spelledNumbers = [
    'Zero',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve'
  ];

  function interactiveInit() {
    checkIntroEligible();
    toggleOtOfferLabel();
    initMultiselectControls();
    initConditionalOptions();
    initVariantControls();
    initFrequencyControls();
    initQuantityControls();
    initPetSelector();
    setInitialState();
    initCartAddListeners();
    parseHistory();
    setSubscriptionImage();

    if (changeDefaultSelection) {
      const target = document.querySelectorAll('label.bag-qty--option')[1];
      target.click();
    }
  }

  const dogIcon = `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485.27 378.97">
        <g>
          <path d="M464.18,124.75c-1.6-2.98-3.23-5.99-4.72-8.82-11.14-21.74-31.9-60.54-45.83-76.47l-2.05-2.29c-11.72-13.2-23.84-26.83-50.52-29.33l-.24-.02c-18.46-1.52-37.07,3.79-51.46,14.15-53.59-20.53-117.8-11.53-133.54-7.51-.21.05-.41.1-.61.15C163.07,4.27,148.16-.96,132.91.15c-4.71.23-15.84,1.74-28.21,10.31-11.69,8.21-70.01,51.71-70.01,101.98v1.7c0,2.05.09,4.73.41,7.81-11.98,7.37-21.38,17.05-26.14,25.6-2.65,4.5-8.96,17.33-8.96,37.57s6.67,43.87,19.68,67.42c7.93,14.73,30.94,34.73,55.8,48.56,4.08,2.31,9.91,5.35,16.72,8.87,17.9,9.29,44.95,23.32,58.37,34.69,13.77,11.45,26.17,18.23,47.16,28.26l2.28,1.09,2.45.6c12.01,2.94,24.59,4.36,38.47,4.36,56.8,0,109.17-28.59,140.07-76.47l1.64-2.54.97-2.86c5.34-15.78,8.92-32.08,10.7-48.69,5.27.61,10.72.77,16.41.49,39.07-1.2,68.76-23.39,73.94-55.63.41-2.88.61-5.7.61-8.63,0-20.81-10.24-39.78-21.08-59.88h-.01ZM468.92,191.21c-3.9,24.03-27.5,40.86-58.54,41.77-11.52.55-21.53-.79-30.73-4.33-.49,21.71-4.21,42.99-11.04,63.36l-.37.98-.55.91c-27.99,43.36-75.37,69.21-126.77,69.21-12.5,0-23.84-1.28-34.7-3.9l-.85-.24-.79-.37c-19.82-9.45-31.4-15.73-43.9-26.16-14.7-12.5-42.81-27.07-61.47-36.71-6.46-3.35-12.01-6.22-15.85-8.42-25-13.96-44.27-32.2-49.64-42.2-11.83-21.46-17.87-41.65-17.87-60s6.4-29.03,6.71-29.45c4.57-8.48,16.1-19.09,30.24-25.06-2.01-7.13-2.26-13.48-2.26-16.46v-1.71c0-35.18,39.76-72.5,63.3-88.97,10.43-7.32,19.51-7.5,19.82-7.5,17.99-1.46,30.49,9.09,36.95,16.46,3.11-.98,6.16-1.83,9.09-2.56,14.57-3.72,82.02-12.87,132.38,10.49,11.77-11.77,29.64-18.23,47.5-16.71,20.43,1.95,28.66,11.16,40.06,23.96l2.2,2.5c12.44,14.21,32.62,51.83,43.48,72.99l5,9.39c9.82,18.23,19.09,35.43,19.09,52.14,0,2.19-.12,4.39-.49,6.59h0Z"/>
          <path d="M230.28,124.87c.28.89.6,1.76,1.01,2.6.22.46.46.9.71,1.34.51.87,1.1,1.69,1.76,2.49.28.35.54.7.85,1.03.88.93,1.88,1.78,2.97,2.55.17.12.29.29.47.41,5.49,3.74,12.22,4.23,17.96,1.93,1.82-.73,3.5-1.82,5.05-3.11,1.37-1.13,2.65-2.4,3.7-3.94.68-1.02,1.23-2.08,1.7-3.17.12-.27.21-.53.31-.8.35-.91.63-1.83.83-2.76.04-.2.1-.4.14-.61.22-1.18.37-2.38.37-3.58,0-.41-.12-.81-.15-1.21-.06-.96-.14-1.91-.34-2.84-.12-.57-.31-1.12-.48-1.68-.25-.83-.54-1.64-.9-2.43-.23-.51-.48-1-.76-1.49-.47-.84-1.02-1.62-1.62-2.38-.3-.38-.56-.77-.89-1.12-.97-1.06-2.03-2.04-3.26-2.88-.03-.02-.04-.04-.07-.06-6.82-4.48-15.25-4.16-21.53.02-2.1,1.38-3.96,3.19-5.45,5.39-.21.32-.34.66-.53.98-.4.66-.78,1.32-1.09,2.01-.17.38-.31.77-.45,1.16-.29.77-.53,1.55-.71,2.34-.07.29-.15.58-.2.88-.2,1.12-.34,2.25-.34,3.38,0,.2.07.4.07.6.04,1.18.18,2.35.43,3.5.11.5.29.97.44,1.46h0Z"/>
          <path d="M72.44,191.21c21.59,0,38.9-10.79,38.9-24.15s-17.32-24.39-38.9-24.39-38.9,11.1-38.9,24.39,17.32,24.15,38.9,24.15Z"/>
          <path d="M105.67,251.46c2.01.85,26.4,11.4,63.36,11.4,30.37,0,69.03-7.13,110.49-31.83.85-3.66,1.52-7.13,2.01-10.37.37-2.13.61-4.15.79-6.1,1.89-19.27-2.99-29.03-7.87-33.9-.49-.55-1.04-.98-1.52-1.4-2.07-1.65-3.96-2.5-5.24-2.93-.31-.12-.61-.18-.79-.24-.49-.12-.73-.18-.73-.18-27.56-4.82-39.76,26.4-47.99,48.6-8.23,22.14-27.56,26.71-33.54,27.81-44.33,3.42-74.45-9.39-75-9.63l-3.96,8.78h-.01Z"/>
          <path d="M125.27,131.86c8.81,5.97,20.74,3.69,26.71-5.11,5.97-8.81,3.69-21.02-5.11-26.99-8.81-5.97-21.02-3.41-26.99,5.4-5.97,8.81-3.41,20.74,5.4,26.71h-.01Z"/>
          </g>
        </svg>
    `;

  /* ------------------------------------------------------------------------------------------------

    Utilities

    ------------------------------------------------------------------------------------------------  */

  // Check whether page is loaded via back button
  function checkNavStates() {
    let perfEntries = performance.getEntriesByType('navigation');
    if (perfEntries.length > 0) {
      let p = perfEntries[0];
      if (p.type === 'back_forward') {
        return true;
      }
      return false;
    }
  }

  // Rounds number to two decimal points
  function parseRound(number) {
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }

  // Returns subscription frequency value
  function parseFrequency(valueString) {
    let frequencyString = valueString.replace('Delivery every ', '');
    frequencyString = frequencyString.split(' ')[0];
    return parseInt(frequencyString);
  }

  // Returns frequency discount
  function parseFrequencyDiscount(frequency) {
    let discountRate;
    if (frequency < 3) {
      discountRate = priceScale[frequency];
    } else {
      discountRate = priceScale[3];
    }
    return discountRate;
  }

  // Removes class hidden from single target
  function unhide(element) {
    if (!element) return;
    element.classList.remove('hidden');
  }

  // Adds class hidden to single target
  function hide(element) {
    if (!element) return;
    element.classList.add('hidden');
  }

  // Removes class hidden from array of targets
  function bulkUnhide(array) {
    if (array.length === 0) return;
    array.forEach((obj) => {
      unhide(obj);
    });
  }

  // Adds class hidden to array of targets
  function bulkHide(array) {
    if (array.length === 0) return;
    array.forEach((obj) => {
      hide(obj);
    });
  }

  // Adds specific class to array of targets
  function bulkClassList(method, targets, className) {
    if (targets.length === 0) return;
    if (method === 'add') {
      targets.forEach((target) => {
        target.classList.add(className);
      });
    } else {
      targets.forEach((target) => {
        target.classList.remove(className);
      });
    }
  }

  // Returns scaled image url
  function parseImageSrc(src, dimensions) {
    if (!src) return null;
    let srcArray = src.split('.');
    let srcEnd = srcArray[srcArray.length - 1];
    let stringStart = src.replace(`.${srcEnd}`, '');
    let imageUrl = `${stringStart}${dimensions}.${srcEnd}`;
    return imageUrl;
  }

  // Returns variant kcal / gram
  function getVariantNutrition(id) {
    if (!variantNutrition) return;
    let data = variantNutrition.find((option) => option.id === id);
    return data;
  }

  // Returns size integer given size string with grams
  function parseGramSizeInt(sizeString) {
    return parseInt(sizeString.replace('g', ''));
  }

  // Returns size integer given size string with text and oz
  function parseOzSizeInt(sizeString) {
    const match = sizeString.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  // Updates textcontent for each item in an array
  function bulkUpdateDisplayContent(array, content) {
    array.forEach((item) => {
      item.textContent = content;
    });
  }

  // Updates innerHtml for each item in an array
  function bulkUpdateDisplayHtml(array, content) {
    array.forEach((item) => {
      item.innerHTML = content;
    });
  }

  // Turns decimals into fractions
  function parseFractionCups(decimal) {
    if (decimal === '0.125' || decimal === '125') {
      return '1/8';
    } else if (decimal === '0.25' || decimal === '25') {
      return '1/4';
    } else if (decimal === '0.375' || decimal === '375') {
      return '3/8';
    } else if (decimal === '0.5' || decimal === '5') {
      return '1/2';
    } else if (decimal === '0.625' || decimal === '625') {
      return '5/8';
    } else if (decimal === '0.75' || decimal === '75') {
      return '3/4';
    } else if (decimal === '0.875' || decimal === '875') {
      return '7/8';
    } else {
      return '';
    }
  }

  // Checks whether item is applicable for offer
  function parseItemOfferEligibility(offerData, itemId) {
    if (!offerData || !offerData.item_ids || offerData.item_ids.length === 0)
      return false;
    return offerData.item_ids.includes(itemId);
  }

  // Returns form type data (Fresh / FFD)
  function parseUnitType(wrapper) {
    return {
      type: wrapper.getAttribute('data-serving-type'),
      unit: wrapper.getAttribute('data-unit-measure')
    };
  }

  // Checks whether subscription options are currently selected
  function checkSubscription(form) {
    if (form.getAttribute('data-subscription-only') === 'true') return true;

    const isSubscription = form.querySelector(
      '[data-group="subscription-options"] input[type="radio"]:checked'
    );
    if (isSubscription && isSubscription.value === 'true') {
      return true;
    }
    const checkboxSubscription = form.querySelector(
      '[data-content="autoship-toggle"]:checked'
    );
    if (checkboxSubscription) {
      return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------------------------------------

    Initial State

    ------------------------------------------------------------------------------------------------  */

  function checkIntroEligible() {
    document
      .querySelectorAll('[data-content-type="intro-offer"]')
      .forEach((element) => {
        const form = element.closest('[data-content="product-form"]');
        const formProductId = form.getAttribute('data-form-product')
          ? parseInt(form.getAttribute('data-form-product'))
          : 9999999999999;
        const subParent = form.querySelector(
          '[data-group="subscription-options"]'
        );
        const checkedOption = subParent
          ? subParent.querySelector('input[type="radio"]:checked')
          : null;
        const subscriptionSelected = checkedOption
          ? checkedOption.value === 'true'
          : false;

        productApplicable = false;

        if (offer) {
          let offerData = parseOfferDetails(offer);
          let originalOfferData = parseOfferDetails(offer);
          productApplicable = parseItemOfferEligibility(
            offerData,
            formProductId
          );
          if (
            offerData.apply_ss &&
            offerData.discount &&
            subscriptionSelected &&
            productApplicable
          ) {
            currentOfferData = offerData;
            unhide(element);
          } else if (subscriptionSelected) {
            if (
              offerData.apply_ss ||
              offerData.paired_offer ||
              offerData.stackable_offers
            ) {
              if (
                offerData.paired_offer &&
                parseOfferDetails(offerData.paired_offer).apply_ss
              ) {
                offerData = parseOfferDetails(offerData.paired_offer);
                currentOfferData = offerData;
              }
              productApplicable = parseItemOfferEligibility(
                offerData,
                formProductId
              );
              if (productApplicable) {
                let label = element.querySelector(
                  '[data-content="offer-label"]'
                );
                if (label) {
                  if (offerData.offer_label_pdp) {
                    label.textContent = offerData.offer_label_pdp;
                  } else {
                    label.textContent = 'Offer Price';
                  }
                }
                unhide(element);
              } else {
                if (
                  originalOfferData.stackable_offers &&
                  originalOfferData.stackable_offers.length > 0
                ) {
                  let applicableFound = false;
                  for (
                    let i = 0;
                    i < originalOfferData.stackable_offers.length;
                    i++
                  ) {
                    let stackableOffer = parseOfferDetails(
                      originalOfferData.stackable_offers[i]
                    );
                    if (
                      parseItemOfferEligibility(stackableOffer, formProductId)
                    ) {
                      applicableFound = true;
                      productApplicable = true;
                      offerData = stackableOffer;
                      offer = offerData.name;
                      break;
                    }
                  }
                }
              }
            }
          }
          if (
            element.getAttribute('data-label') === 'intro-frequency-label' &&
            offerData.ss_frequency_message &&
            offerData.ss_frequency_message !== '' &&
            productApplicable
          ) {
            element.innerHTML = offerData.ss_frequency_message;
          }
        }

        if (!productApplicable) {
          const updates = form.querySelectorAll(
            '[data-content-type="intro-offer"]'
          );
          updates.forEach((update) => {
            update.removeAttribute('data-content-type');
            update.removeAttribute('data-option-set');
            update.removeAttribute('data-content');
          });
        }
        if (!offer || !productApplicable) {
          const ssIntroContents = form.querySelectorAll(
            '[data-content-for="intro-offer"]'
          );
          ssIntroContents.forEach((element) => {
            element.remove();
          });
        }
      });
  }

  function parseHistory() {
    let backNav = checkNavStates();
    if (
      backNav &&
      document.querySelector('[data-content="shipment-frequency"]')
    ) {
      setTimeout(() => {
        // This is a less than ideal solution, but it works for now
        document
          .querySelector('[data-content="shipment-frequency"]')
          .dispatchEvent(new Event('change'));
      }, 1000);
    }
  }

  function toggleOtOfferLabel() {
    if (!offer) return;
    const otLabels = document.querySelectorAll(
      '[data-content="ot-price-label"]'
    );
    let offerData = parseOfferDetails(offer);
    if (
      offerData.apply_one_time ||
      (offerData.paired_offer &&
        parseOfferDetails(offerData.paired_offer).apply_one_time)
    ) {
      bulkUnhide(otLabels);
    }
  }

  function setInitialState() {
    // Check for pet selection
    let selectedPet = localStorage.getItem('selectedPet');
    if (!selectedPet) {
      let forms = document.querySelectorAll('[data-content="product-form"]');
      forms.forEach((form) => {
        const petSelector = form.querySelector(
          '[data-action="clear-pet-selection"]'
        );
        if (petSelector) {
          petSelector.click();
        }
        let serving = parseUnitType(form);
        if (serving.unit === 'grams' && serving.type === 'preset') {
          // FRESH PATH
          form.querySelector('[data-content="variant-quantity"]').value = 2;
        }
      });
    }
    handleVariantChange();
  }

  /* ------------------------------------------------------------------------------------------------

    Pet Selector Functionality

    ------------------------------------------------------------------------------------------------  */

  function initPetSelector() {
    fillPetOptions();
    setPetListeners();
    setClearListener();
    selectCurrentPet();
    initPetAddTriggers();
  }

  function getPets() {
    const storageItem = localStorage.getItem('petProfiles');
    const pets = storageItem ? JSON.parse(storageItem) : null;
    return pets ? pets.pets || [] : [];
  }

  function fillPetOptions() {
    const pets = getPets();
    const petInputContainers = document.querySelectorAll(
      '[data-content="pdp-pet-options"]'
    );
    if (pets.length === 0) {
      petInputContainers.forEach((group) => {
        continueWithoutPet(group);
      });
      return;
    }
    const allPetInputs = pets
      .map((pet, i) => generatePetInput(pet, i))
      .join('');
    petInputContainers.forEach((group) => {
      group.insertAdjacentHTML('beforeend', allPetInputs);
    });
  }

  function spliceNewPetOption(newId) {
    const pets = getPets();
    let newPet = pets.find((pet) => pet.id === newId);
    const petInputContainers = document.querySelectorAll(
      '[data-content="pdp-pet-options"]'
    );
    petInputContainers.forEach((group) => {
      group.insertAdjacentHTML(
        'beforeend',
        generatePetInput(newPet, pets.length - 1)
      );
    });
  }

  function selectCurrentPet() {
    let id = localStorage.getItem('selectedPet');
    if (id) {
      let inputs = document.querySelectorAll(
        `[data-action="select-pet"][data-dog-id="${id}"]`
      );
      inputs.forEach((input) => {
        input.click();
      });
    }
  }

  function generatePetInput(object, index) {
    // ${dogIcon} renders svg
    return `
            <input type="radio" name="form-dog" id="form-dog-${index}" value="${object.name}" data-content="dog-select" data-action="select-pet" data-dog-id="${object.id}">
            <label class="pdp-pet--button" for="form-dog-${index}" data-content="dog-select" data-dog-id="${object.id}">
                <div class="dog-icon--wrapper">
                </div>
                <span class="pdp-pet--name body-sm-b uppercase">${object.name}</span>
            </label>
        `;
  }

  function continueWithoutPet(element) {
    let parent = element.closest('[data-content="product-form"]');
    let serving = parseUnitType(parent);
    if (serving.type === 'preset' && serving.unit === 'grams') {
      // Fresh Meal Path
      let portionToggle = parent.querySelector(
        '[data-content="portion-toggle"]'
      );
      hide(portionToggle);
      portionToggle.querySelector('input[type="radio"][value="true"]').checked =
        true;
      unhide(
        parent.querySelector(
          '[data-content="conditional-content"][data-option-set="portion-adjust"]'
        )
      );
    } else {
      bulkHide(parent.querySelectorAll(`[data-content="ffd-pet-conditional"]`));
      bulkHide(parent.querySelectorAll('[data-parent-for="variant-cost-day"]'));
      bulkHide(
        parent.querySelectorAll('[data-parent-for="variant-cost-serving"]')
      );
    }
  }

  function setPetListeners() {
    let petInputs = document.querySelectorAll('[data-action="select-pet"]');
    petInputs.forEach((option) => {
      option.addEventListener('change', petSelected);
    });
  }

  function resetPetListeners() {
    let petInputs = document.querySelectorAll('[data-action="select-pet"]');
    petInputs.forEach((option) => {
      option.removeEventListener('change', petSelected);
    });
  }

  function setClearListener() {
    let clearPetTriggers = document.querySelectorAll(
      '[data-action="clear-pet-selection"]'
    );
    clearPetTriggers.forEach((trigger) => {
      trigger.addEventListener('click', resetPetSelection);
    });
  }

  function resetPetSelection() {
    let resetEvent = new Event('petSelection:clear');
    document.dispatchEvent(resetEvent);
  }

  function petSelected() {
    let petId = this.getAttribute('data-dog-id');
    localStorage.setItem('selectedPet', petId);
    let selectedEvent = new Event('petSelection:selected');
    document.dispatchEvent(selectedEvent);
  }

  function handlePetSelection() {
    let petId = localStorage.getItem('selectedPet');
    let petData = getPetData(petId);
    // Update display names
    let displayTargets = document.querySelectorAll('[data-content="dog-name"]');
    bulkUpdateDisplayContent(
      displayTargets,
      petData && petData.name ? petData.name : 'Your Dog'
    );
    calculateRecommendation(petData);
    togglePortionSizeOptions();
    handleSelectDogSize(petData);
    updateAddProps(petData.name);
  }

  function setSubscriptionImage() {
    const target = document.querySelector('[data-subscription-primary="true"]');
    if (!target) return;
    const targetIndex = parseInt(target.getAttribute('data-index')) - 1;
    const clickTarget = document.querySelector(
      `a.product__thumb[data-index="${targetIndex}"]`
    );
    clickTarget.click();
  }

  function updateAddProps(name) {
    setTimeout(function () {
      const valueInput = document.querySelector('[data-for="cart-add"]');
      if (!valueInput) return;
      let data = JSON.parse(valueInput.value);
      if (name) {
        if (!data.properties) data.properties = {};
        data.properties['_Dog Name'] = name;
      } else if (data.properties['_Dog Name']) {
        delete data.properties['_Dog Name'];
      }
      valueInput.value = JSON.stringify(data);
    }, 20);
  }

  function handleSelectDogSize(data) {
    const weight = data.weight ? parseInt(data.weight) : null;
    if (!weight) {
      const selected = document.querySelector(
        '[name="dog-size-options"]:checked'
      );
      if (selected) {
        selected.checked = false;
      }
      return;
    }
    const options = document.querySelectorAll('[name="dog-size-options"]');
    let target;
    for (let i = 0; i < options.length; i++) {
      if (i < options.length - 1) {
        if (weight <= parseInt(options[i].getAttribute('data-max-weight'))) {
          target = options[i];
          break;
        }
      } else {
        target = options[i];
      }
    }
    if (!target) return;
    target.nextElementSibling.click();
  }

  function togglePortionSizeOptions() {
    const titleEl = document.querySelector('[data-product-title]');
    let isSupplement =
      titleEl &&
      titleEl.getAttribute('data-product-title').includes('Supplement');
    if (isSupplement) return;
    let forms = document.querySelectorAll('[data-content="product-form"]');
    forms.forEach((form) => {
      let portionToggle = form.querySelector('[data-content="portion-toggle"]');
      if (portionToggle) {
        unhide(portionToggle);
        let target = portionToggle.querySelector(
          'input[type="radio"][value="false"]'
        );
        if (target) {
          target.checked = true;
        }
        let set = form.querySelector(
          '[data-content="conditional-content"][data-option-set="portion-adjust"]'
        );
        if (set) {
          hide(set);
        }
      }
    });
  }

  function clearPetSelection() {
    localStorage.removeItem('selectedPet');
    bulkUpdateDisplayContent(
      document.querySelectorAll('[data-content="dog-name"]'),
      'Your Dog'
    );
    let petInputs = document.querySelectorAll(
      'input[type="radio"][data-action="select-pet"]'
    );
    petInputs.forEach((input) => {
      input.checked = false;
    });
    let groups = document.querySelectorAll('[data-content="pdp-pet-options"]');
    groups.forEach((group) => {
      continueWithoutPet(group);
    });
    updateAddProps(null);
    const selectedDogSize = document.querySelector(
      '[name="dog-size-options"]:checked'
    );
    if (!selectedDogSize || selectedDogSize.value === 'manual') return;
    selectedDogSize.checked = false;
    document.querySelector('[name="dog-size-options"][value="manual"]').click();
  }

  function getPetData(id) {
    const pets = getPets();
    return pets.find((pet) => pet.id === id) || null;
  }

  /* ------------------------------------------------------------------------------------------------

    Calculate Portion Size

    ------------------------------------------------------------------------------------------------  */

  function calculateRecommendation(pet) {
    const titleEl = document.querySelector('[data-product-title]');
    let isSupplement =
      titleEl &&
      titleEl.getAttribute('data-product-title').includes('Supplement');
    if (isSupplement) return;
    let months = parseAgeMonths(pet.dob_year, pet.dob_month);
    let baseRer = parseRer(pet.weight);
    let sizeGroup = parseSizeGroup(pet);
    let stageData = lifeStageThresholds.find(
      (stage) => stage.size === sizeGroup
    );
    let lifeStage = parseLifestage(stageData, months);
    let mer = parseMer(pet, lifeStage, baseRer);
    document
      .querySelectorAll('[data-content="product-form"]')
      .forEach((form) => {
        let serving = parseUnitType(form);
        if (serving.type === 'preset' && serving.unit === 'grams') {
          // Fresh Meal Path
          let productId = form.getAttribute('data-form-product');
          let variantId = form.getAttribute('data-current-variant');
          let nutrition = getVariantNutrition(parseInt(variantId)); // Get nutrition data specifically for flavor kcal
          let dailyGrams = mer / nutrition.kcal_gram; // Get daily gram intake requirement
          let mealGrams = dailyGrams / 2; // Calc meal gram intake requirement
          let variantSizes = parseAvailableSizes(nutrition.flavor); // Get all sizes of flavor
          let mealSize = parsePresetMealSize(mealGrams, variantSizes); // Find closest match
          setFreshSizeValue(productId, `${mealSize}g`, serving.type);
        } else {
          // FFD Path
          handleDriedAmounts(mer);
        }
      });
  }

  function handleDriedAmounts(energy) {
    if (energy) {
      let flavorNutrition = [];
      variantNutrition.forEach((variant) => {
        let matched = flavorNutrition.find(
          (option) => option.flavor === variant.flavor
        );
        if (!matched) {
          let flavor = {
            flavor: variant.flavor,
            density: variant.density,
            kcal_gram: variant.kcal_gram,
            per_cup: variant.density * variant.kcal_gram
          };
          flavorNutrition.push(flavor);
        }
      });
      let servingAmounts = parseServingAmount(energy, flavorNutrition);
      handleVariantChange(servingAmounts, true);
      bulkUnhide(
        document.querySelectorAll(`[data-content="ffd-pet-conditional"]`)
      );
    }
  }

  function parseAvailableSizes(flavor) {
    let sizeOptions = variantNutrition.filter(
      (object) => object.flavor === flavor
    );
    if (sizeOptions[0].size) {
      // Accounts for option title discrepancies between ffd / fresh
      return sizeOptions.map((option) => parseGramSizeInt(option.size));
    } else {
      return sizeOptions.map((option) => parseOzSizeInt(option.bag_size));
    }
  }

  function parsePresetMealSize(grams, sizes) {
    let mealSize = sizes[0];
    let smallestDifference = Math.abs(grams - mealSize);
    for (let i = 1; i < sizes.length; i++) {
      let size = sizes[i];
      let currentDifference = Math.abs(grams - size);
      if (currentDifference < smallestDifference) {
        smallestDifference = currentDifference;
        mealSize = size;
      }
    }
    return mealSize;
  }

  function parseServingAmount(calories, flavors) {
    const mealMer = calories / 2;

    return flavors.map((flavor) => {
      let mealCups = mealMer / flavor.per_cup;
      let roundedCups = Math.round(mealCups * 8) / 8;
      let [wholeNumber, fractional] = String(roundedCups).split('.');

      let displayAmount = wholeNumber !== '0' ? wholeNumber : '';
      if (fractional) {
        let [numerator, denominator] = parseFractionCups(fractional).split('/');
        displayAmount += ` <sup>${numerator}</sup>/<sub>${denominator}</sub>`;
      }

      let displayUnit = roundedCups === 1 ? 'cup' : 'cups';
      let fullDisplay = `${displayAmount} ${displayUnit}`;

      return {
        flavor_nutrition: flavor,
        meal_cups_value: mealCups,
        meal_cups_rounded: roundedCups,
        meal_cups_html: fullDisplay
      };
    });
  }

  function setFreshSizeValue(formId, size, type) {
    let form = document.querySelector(
      `[data-content="product-form"][data-form-product="${formId}"]`
    );
    let sizeInput = form.querySelector('[data-content="variant-size"]');
    if (sizeInput.type === 'select-one') {
      sizeInput.value = size;
    } else {
      sizeInput = form.querySelector(
        `[data-content="variant-size"][value="${size}"]`
      );
      sizeInput.checked = true;
    }
    handleVariantChange();
  }

  function parseAgeMonths(birthdayYear, birthdayMonth) {
    let dateToday = new Date();
    let birthday = new Date(`${birthdayYear}-${birthdayMonth}-01`);
    return (
      ((birthday.getFullYear() - dateToday.getFullYear()) * 12 +
        (birthday.getMonth() - dateToday.getMonth())) *
      -1
    );
  }

  function parseRer(weight) {
    let kgWeight = parseInt(weight) / 2.2;
    let metabolicWeight = kgWeight ** 0.75;
    return metabolicWeight * 70;
  }

  function parseSizeGroup(petData) {
    if (
      petData.breed === 'Mixed / Other...' ||
      !petData.breed ||
      petData.breed === ''
    ) {
      return parseMixedSize(
        parseAgeMonths(petData.dob_year, petData.dob_month),
        petData.weight
      );
    }
    return petData.other_size &&
      petData.breed === 'Mixed / Other...' &&
      petData.other_size !== ''
      ? petData.other_size
      : parseBreedSize(petData.breed);
  }

  function parseBreedSize(breed) {
    const lowerBreed = breed.toLowerCase();
    if (
      giantBreeds.some((giantBreed) => giantBreed.toLowerCase() === lowerBreed)
    ) {
      return 'giant';
    }
    if (
      largeBreeds.some((largeBreed) => largeBreed.toLowerCase() === lowerBreed)
    ) {
      return 'large';
    }
    if (
      mediumBreeds.some(
        (mediumBreed) => mediumBreed.toLowerCase() === lowerBreed
      )
    ) {
      return 'medium';
    }
    return 'small';
  }

  function parseLifestage(data, age) {
    if (age < data.young_puppy) return 'young_puppy';
    if (age < data.puppy) return 'puppy';
    if (data.puppy_teen && age < data.puppy_teen) return 'puppy_teen';
    if (age < data.adult) return 'adult';
    return 'senior';
  }

  function parseMer(petData, stage, rer) {
    let baseMer;
    // If puppy
    if (['young_puppy', 'puppy', 'puppy_teen'].includes(stage)) {
      baseMer = rer * rerMultipliers[stage];
      return baseMer * merTransform; // Modifys MER based on globally set multiplier (60% - 140% of actual)
    }
    // If pregnant or nursing
    switch (petData.pregnant_nursing) {
      case 'pregnant':
        baseMer = rer * rerMultipliers[`pregnant_${petData.pregnancy_stage}`];
        return baseMer * merTransform; // Modifys MER based on globally set multiplier (60% - 140% of actual)
      case 'nursing':
        baseMer = rer * rerMultipliers['nursing'];
        return baseMer * merTransform; // Modifys MER based on globally set multiplier (60% - 140% of actual)
    }
    // Otherwise
    let baseStage = stage;
    if (petData.spayed_neutered === 'true' || !petData.spayed_neutered) {
      baseStage += '_fixed';
    }
    baseMer = rer * rerMultipliers[baseStage];
    let activityValue =
      (petData.activity && petData.activity.toLowerCase()) || 'average';
    let activityEnergy = parseConditionalEnergy(
      'activity',
      activityValue,
      baseMer
    );
    let weightGoalValue =
      (petData.weight_goal && petData.weight_goal.toLowerCase()) || 'maintain';
    let goalEnergy = parseConditionalEnergy('goal', weightGoalValue, baseMer);
    let mer = baseMer + activityEnergy + goalEnergy;
    return mer * merTransform; // Modifys MER based on globally set multiplier (60% - 140% of actual)
  }

  function parseConditionalEnergy(type, value, base) {
    let keyType = type.replace('-', '_');
    let keyValue = value.replace('-', '_');
    let multiplier = conditionalMultipliers[keyType][keyValue];
    return base * multiplier - base;
  }

  function parseMixedSize(age, weight) {
    let calcWeight;
    if (age < 3) {
      calcWeight = weight * 2.5;
    } else if (age < 5) {
      calcWeight = weight * 1.75;
    } else if (age < 8) {
      calcWeight = weight * 1.5;
    } else if (age < 12) {
      calcWeight = weight * 1.2;
    } else {
      calcWeight = weight;
    }
    return calcWeight <= 25
      ? 'small'
      : calcWeight <= 50
        ? 'medium'
        : calcWeight <= 90
          ? 'large'
          : 'giant';
  }

  /* ------------------------------------------------------------------------------------------------

    Multiselect Functionality

    ------------------------------------------------------------------------------------------------  */

  function initMultiselectControls() {
    let multiselects = document.querySelectorAll(
      '[data-type="multiselect-group"]'
    );
    if (multiselects.length > 0) {
      multiselects.forEach((group) => {
        controlMultiselect(group);
      });
    }
  }

  function controlMultiselect(multiselect) {
    let max = parseInt(multiselect.getAttribute('data-max'));
    if (max) {
      let options = multiselect.querySelectorAll('input[type="checkbox"]');
      options.forEach((option) => {
        option.addEventListener('change', () =>
          multiselectChange(multiselect, max)
        );
      });
    }
    // Check for clear button
    let clearTriggers = multiselect.querySelectorAll('[data-action="clear"]');
    if (clearTriggers.length > 0) {
      clearTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => multiselectClear(multiselect));
      });
    }
  }

  function multiselectChange(group, maxOptions) {
    const checkboxes = Array.from(
      group.querySelectorAll('input[type="checkbox"]')
    );
    const selectedCount = checkboxes.filter(
      (checkbox) => checkbox.checked
    ).length;

    checkboxes.forEach((checkbox) => {
      checkbox.disabled = !checkbox.checked && selectedCount >= maxOptions;
    });

    const closestProductForm = group.closest('[data-content="product-form"]');
    toggleCartAdd(
      closestProductForm,
      selectedCount > 0 || (selectedCount === 0 && maxOptions === 0)
    );
  }

  function multiselectClear(group) {
    let options = group.querySelectorAll('input[type="checkbox"]');
    let selected = group.querySelectorAll('input[type="checkbox"]:checked');
    selected.forEach((option) => {
      option.checked = false;
    });
    options.forEach((option) => {
      option.disabled = false;
    });
    handleVariantChange();
    toggleCartAdd(group.closest('[data-content="product-form"]'), false);
  }

  function toggleCartAdd(form, enable = true) {
    let button = form.querySelector('[data-action="cart-add"]');
    let summary = form.querySelector('[data-content="meal-summary-ready"]');
    if (enable) {
      summary.classList.remove('hidden');
      button.disabled = false;
      button.textContent = 'Add To Cart';
    } else {
      summary.classList.add('hidden');
      button.disabled = true;
      button.textContent = 'Select Flavor to Add To Cart';
    }
  }

  /* ------------------------------------------------------------------------------------------------

    Conditional Options Toggle

    ------------------------------------------------------------------------------------------------  */

  function initConditionalOptions() {
    let optionGroups = document.querySelectorAll(
      '[data-content="conditional-options-toggle"]'
    );
    if (optionGroups.length > 0) {
      optionGroups.forEach((group) => {
        controlConditionalOptions(group);
      });
    }
  }

  function controlConditionalOptions(set) {
    let setId = set.getAttribute('data-option-set');
    if (setId) {
      let setOptionPanels = document.querySelectorAll(
        `[data-content="conditional-content"][data-option-set="${setId}"]`
      );
      let options = set.querySelectorAll('input[type="radio"]');
      options.forEach((option) => {
        option.addEventListener('change', () => {
          let qtyBypassProp = option.getAttribute('data-quantity-ignore');
          let bypassQuantity =
            qtyBypassProp && qtyBypassProp === 'true' ? true : false;
          let presetQuantity =
            parseInt(option.getAttribute('data-preset-quantity')) || null;
          conditionalChange(
            option.value,
            setOptionPanels,
            setId,
            bypassQuantity,
            presetQuantity
          );
          if (option.value == 'false' && localStorage.getItem('selectedPet')) {
            handlePetSelection();
          }
        });
      });
    }
  }

  function conditionalChange(value, targets, group, bypass, preset) {
    targets.forEach((target) => {
      if (
        target.getAttribute('data-direction') &&
        target.getAttribute('data-direction') === 'inverse'
      ) {
        if (value !== 'true') {
          unhide(target);
        } else {
          hide(target);
        }
      } else {
        if (value === 'true') {
          unhide(target);
        } else {
          hide(target);
        }
      }
    });
    if (group === 'subscription-main') {
      let quantityInput = document.querySelector(
        '[data-content="variant-quantity"]'
      );
      if (!bypass) {
        if (value === 'false') {
          quantityInput.value = 1;
        } else {
          quantityInput.value = parseFrequency(
            document.querySelector('select[data-content="shipment-frequency"]')
              .value
          );
        }
      } else if (bypass && preset) {
        quantityInput.value = preset;
      }
      updateFrequencyOfferDisplay(
        parseFrequency(
          document.querySelector('select[data-content="shipment-frequency"]')
            .value
        )
      );
      handleSubscriptionImageToggle(value);
    }
    handleVariantChange();
  }

  function handleSubscriptionImageToggle(value) {
    let subscriptionImage = document.querySelector(
      '[data-subscription-primary="true"]'
    );
    if (!subscriptionImage) return;
    if (value === 'true') {
      setSubscriptionImage();
    } else {
      const clickTarget = document.querySelector(
        `a.product__thumb[data-index="0"]`
      );
      clickTarget.click();
    }
  }

  /* ------------------------------------------------------------------------------------------------

    Variant Change Options

    ------------------------------------------------------------------------------------------------  */

  function initVariantControls() {
    document
      .querySelectorAll('[data-content="product-form"]')
      .forEach((form) => {
        let inputs = form.querySelectorAll('[data-option-name]');
        inputs.forEach((input) => {
          input.addEventListener('change', handleFlavorChange);
        });
      });
  }

  function handleFlavorChange() {
    if (
      localStorage.getItem('selectedPet') &&
      document.getElementById('size-true') &&
      !document.getElementById('size-true').checked
    ) {
      updateFormVariantId(getSelectedVariant());
      handlePetSelection();
    } else {
      handleVariantChange();
    }
  }

  function handleImageDisplay(formEl, selectedVariant) {
    let flavorIndex = optionTitles.indexOf('flavor');
    if (flavorIndex !== -1) {
      let flavorOption = `option${flavorIndex + 1}`;
      let section = formEl.closest('.page-width');
      let thumbnails = section.querySelectorAll('.product__thumb-item');
      let imageSet = section.querySelectorAll(
        '.product__thumb-item[data-set-name="flavor"]'
      );
      let firstThumb;
      if (imageSet.length > 0) {
        thumbnails.forEach((thumbnail) => {
          if (
            thumbnail.getAttribute('data-group') ===
              `flavor_${selectedVariant[flavorOption].toLowerCase().replaceAll(' ', '-')}` ||
            thumbnail.getAttribute('data-group') === 'flavor_all'
          ) {
            thumbnail.classList.remove('hide');
            if (!firstThumb) {
              firstThumb = thumbnail;
            }
          } else {
            thumbnail.classList.add('hide');
          }
        });
      }
      firstThumb.querySelector('a').click();
    }
  }

  function handleVariantChange(amounts, isJson) {
    let variant = getSelectedVariant();
    updateFormVariantId(variant);
    let form = document.querySelector(
      `[data-content="product-form"][data-current-variant="${variant.id}"]`
    );

    const subscriptionToggler = form.querySelector(
      '[data-content="autoship-toggle"]'
    );
    const subscriptionActive = subscriptionToggler
      ? subscriptionToggler.checked
      : false;
    const priceControls = {
      subscription_active: subscriptionActive,
      discount_rate:
        subscriptionActive &&
        subscriptionToggler &&
        subscriptionToggler.getAttribute('data-discount-rate')
          ? parseFloat(subscriptionToggler.getAttribute('data-discount-rate'))
          : 1
    };

    handleImageDisplay(form, variant);
    updateFormAddContent(form, variant.id);
    let pricing = parseOptionPricing(variant, form);
    let serving = parseUnitType(form);
    if (serving.type === 'preset' && serving.unit === 'grams') {
      updateFreshDisplayContent(pricing, variant);
    } else {
      if (!isJson) {
        // Functionality changes slightly based on where the function was invoked
        if (localStorage.getItem('selectedPet') && amounts) {
          let selectedPet = getPetData(localStorage.getItem('selectedPet'));
          calculateRecommendation(selectedPet);
        } else {
          updateDriedDisplayContent(form, pricing, null, variant);
        }
      } else {
        let matchedAmount = amounts.find(
          (amount) => amount.flavor_nutrition.flavor === variant.option1
        );
        if (matchedAmount) {
          updateDriedDisplayContent(form, pricing, matchedAmount, variant);
        }
      }
    }
    const priceDisplays = form.querySelectorAll(
      '[data-content="option-variant-price"]'
    );

    if (priceDisplays.length > 0) {
      updateOptionPrices(priceDisplays, variant, priceControls);
    }

    // Temporary patch in response to request to change default frequency based on bundle size
    // Going to be a hack because it should only be in use for a couple weeks
    if (
      variant.featured_image &&
      variant.featured_image.product_id === 7044876435502
    ) {
      handleFfdFrequencyCustomization(variant);
    }
  }

  // Handles variant level price display updates on variant change
  function updateOptionPrices(priceDisplays, variant, priceControls) {
    const optionCount =
      variant.option3 !== null ? 3 : variant.option2 !== null ? 2 : 1;
    const matchVariableCount = optionCount - 1;

    const formParent =
      priceDisplays[0].closest('.product-section') ||
      document.querySelector('main');

    const firstChildOption = formParent.querySelector(
      '[data-child-option-index]'
    );
    const childOptionIndex = firstChildOption
      ? firstChildOption.getAttribute('data-child-option-index')
      : null;

    if (!firstChildOption) return;

    const firstParentOption = formParent.querySelector(
      '[data-parent-option-index]'
    );
    const parentOptionIndex = firstParentOption
      ? firstParentOption.getAttribute('data-parent-option-index')
      : null;

    const indexOptions = ['1', '2', '3'];

    const parentOption = `option${parentOptionIndex}`;

    let additionalOption = null;
    if (matchVariableCount > 1) {
      const additionalIndex = indexOptions.find(
        (index) => index !== childOptionIndex && index !== parentOptionIndex
      );
      additionalOption = `option${additionalIndex}`;
    }

    const filteredOptions =
      matchVariableCount > 1
        ? variantData.filter(
            (item) =>
              item[parentOption] === variant[parentOption] &&
              item[additionalOption] === variant[additionalOption]
          )
        : variantData.filter(
            (item) => item[parentOption] === variant[parentOption]
          );

    for (let i = 0; i < priceDisplays.length; i++) {
      const parent = priceDisplays[i].closest('label');
      const wrapper = priceDisplays[i].closest('.option-price--label');

      const price = filteredOptions[i].price * 0.01;
      wrapper.setAttribute(
        'data-variant-price',
        filteredOptions[i].price * 0.01
      );

      const comparePrice = filteredOptions[i].compare_at_price * 0.01;
      wrapper.setAttribute(
        'data-variant-compare-price',
        comparePrice ? comparePrice.toFixed(2) : ''
      );

      const priceDisplay = priceDisplays[i];
      const compareDisplay = parent.querySelector(
        '[data-content="option-compare-price"]'
      );

      priceDisplay.textContent = `$${(price * priceControls.discount_rate).toFixed(2)}`;
      compareDisplay.textContent = comparePrice
        ? `$${comparePrice.toFixed(2)}`
        : priceControls.subscription_active
          ? `$${price.toFixed(2)}`
          : '';
      compareDisplay.classList.toggle(
        'hidden',
        compareDisplay.textContent === ''
      );
    }
  }

  function updateFormAddContent(productForm, variantId) {
    let productId = productForm.getAttribute('data-form-product');
    let quantityInput = productForm.querySelector(
      '[data-content="variant-quantity"]'
    );
    let cartAddData = {
      id: variantId,
      quantity: quantityInput ? parseInt(quantityInput.value) : 1
    };
    if (productId === '7044876435502' || productId === '7059447250990') {
      cartAddData.properties = {
        _uts: `${new Date().getTime()}`
      };
    }
    if (
      localStorage.getItem('selectedPet') &&
      productForm.querySelector('[data-block-type="pet-selector"]')
    ) {
      let selectedPet = getPetData(localStorage.getItem('selectedPet'));
      if (cartAddData.properties) {
        cartAddData.properties['_Dog Name'] = selectedPet.name;
      } else {
        cartAddData.properties = {
          '_Dog Name': selectedPet.name
        };
      }
    }
    let isSubscription = checkSubscription(productForm);
    // if (isSubscription && productId === '7044876435502') {
    //     if (cartAddData.properties) {
    //         cartAddData.properties["_whistle_promo_item"] = 'true'
    //     } else {
    //         cartAddData.properties = {
    //             "_whistle_promo_item": 'true'
    //         }
    //     }
    // }
    let selector = productForm.querySelector(
      'select[data-content="shipment-frequency"]'
    );
    let sellingPlan = productForm.querySelector(
      '[data-content="autoship-toggle"]:checked'
    );

    let sellingPlanValue = sellingPlan ? sellingPlan.value : null;
    if (isSubscription && selector) {
      let selectedOption = selector.options[selector.selectedIndex];
      let sellingPlan = selectedOption.getAttribute('data-selling-plan-value');
      cartAddData.selling_plan = sellingPlan;
      if (cartAddData.properties) {
        cartAddData.properties['_subscription_frequency'] = selector
          .querySelector(`option:checked`)
          .getAttribute('data-option-frequency');
      } else {
        cartAddData.properties = {
          _subscription_frequency: selector
            .querySelector(`option:checked`)
            .getAttribute('data-option-frequency')
        };
      }
    } else if (isSubscription && sellingPlanValue) {
      cartAddData.selling_plan = sellingPlanValue;
      if (cartAddData.properties) {
        cartAddData.properties['_subscription_frequency'] =
          sellingPlan.getAttribute('data-selling-plan-value');
      } else {
        cartAddData.properties = {
          _subscription_frequency: sellingPlan.getAttribute(
            'data-selling-plan-value'
          )
        };
      }
    } else if (isSubscription && !selector && !sellingPlanValue) {
      let planId = productForm.getAttribute('data-default-plan');
      let planFrequency = productForm.getAttribute('data-default-frequency');
      cartAddData.selling_plan = planId;
      if (cartAddData.properties) {
        cartAddData.properties['_subscription_frequency'] = planFrequency;
      } else {
        cartAddData.properties = {
          _subscription_frequency: planFrequency
        };
      }
    }
    productForm.querySelector(
      `[data-content="cart-add-json--${productId}"]`
    ).value = JSON.stringify(cartAddData);
  }

  function parseDriedCosts(variant, nutrition, pricing) {
    let quantity = parseInt(
      document.querySelector('[data-content="variant-quantity"]').value
    );
    let dailyGrams =
      nutrition.meal_cups_value * nutrition.flavor_nutrition.density;
    let daysPerBag =
      (parseOzSizeInt(variant.option2) * 28.3495) / dailyGrams / 2;
    let divisible =
      pricing.one_time.offer_price * quantity || pricing.one_time.full_price;
    let dailyCost = divisible / daysPerBag;
    let result = {
      bag_days: daysPerBag,
      one_time: {
        ...pricing.one_time,
        per_day: dailyCost / quantity,
        per_meal: dailyCost / 2 / quantity
      }
    };
    if (pricing.autoship) {
      let dailyCostAutoship = pricing.autoship.unit_price / daysPerBag;
      result.autoship = {
        ...pricing.autoship,
        per_day: dailyCostAutoship / quantity,
        per_meal: dailyCostAutoship / 2 / quantity
      };
    }
    return result;
  }

  function updatePriceDisplayContent(form, pricing) {
    let subscriptionPriceDisplays = form.querySelectorAll(
      '[data-content="subscription-price"]'
    );
    let oneTimePriceDisplays = form.querySelectorAll(
      '[data-content="one-time-price"]'
    );
    let oneTimeOfferDisplays = form.querySelectorAll(
      '[data-content="ot-offer-price"]'
    );

    // Set the price content for one-time displays
    bulkUpdateDisplayContent(
      oneTimePriceDisplays,
      `$${pricing.one_time.full_price.toFixed(2)}`
    );

    if (pricing.autoship) {
      // For subscription: show subscription price, hide one-time price
      bulkUpdateDisplayContent(
        subscriptionPriceDisplays,
        `$${pricing.autoship.unit_price.toFixed(2)}`
      );

      // Hide the one-time price comparison when subscription is active
      bulkHide(form.querySelectorAll('[data-content-type="one-time-compare"]'));

      if (pricing.autoship.per_meal) {
        bulkUpdateDisplayContent(
          form.querySelectorAll('[data-content="variant-cost-serving"]'),
          `$${pricing.autoship.per_meal.toFixed(2)}`
        );
        bulkUnhide(
          form.querySelectorAll('[data-parent-for="variant-cost-serving"]')
        );
      } else {
        bulkHide(
          form.querySelectorAll('[data-parent-for="variant-cost-serving"]')
        );
      }

      if (pricing.autoship.per_day) {
        bulkUpdateDisplayContent(
          form.querySelectorAll('[data-content="variant-cost-day"]'),
          `$${pricing.autoship.per_day.toFixed(2)}`
        );
        bulkUnhide(
          form.querySelectorAll('[data-parent-for="variant-cost-day"]')
        );
      } else {
        bulkHide(form.querySelectorAll('[data-parent-for="variant-cost-day"]'));
      }

      if (pricing.autoship.intro_price) {
        let introPriceDisplays = form.querySelectorAll(
          '[data-content="intro-offer-price"]'
        );
        bulkUpdateDisplayContent(
          introPriceDisplays,
          `$${pricing.autoship.intro_price.toFixed(2)}`
        );
      }

      bulkUnhide(subscriptionPriceDisplays);
    } else {
      // For one-time purchase: show one-time price, hide subscription price
      bulkHide(subscriptionPriceDisplays);
      bulkUnhide(oneTimePriceDisplays);

      if (pricing.one_time.offer_price) {
        bulkUpdateDisplayContent(
          oneTimeOfferDisplays,
          `$${pricing.one_time.offer_price.toFixed(2)}`
        );
        bulkClassList('add', oneTimePriceDisplays, 'summary-metric--slash');
        bulkUnhide(oneTimeOfferDisplays);
      } else {
        bulkHide(oneTimeOfferDisplays);
      }

      if (pricing.one_time.per_meal) {
        bulkUpdateDisplayContent(
          form.querySelectorAll('[data-content="variant-cost-serving"]'),
          `$${pricing.one_time.per_meal.toFixed(2)}`
        );
      }

      if (pricing.one_time.per_day) {
        bulkUpdateDisplayContent(
          form.querySelectorAll('[data-content="variant-cost-day"]'),
          `$${pricing.one_time.per_day.toFixed(2)}`
        );
      }
    }
  }

  function updateDriedDisplayContent(
    parent,
    priceList,
    feeding,
    selectedVariant
  ) {
    if (feeding && feeding !== null) {
      let finalPricing = parseDriedCosts(selectedVariant, feeding, priceList);
      bulkUpdateDisplayContent(
        parent.querySelectorAll('[data-content="bag-longevity"]'),
        String(finalPricing.bag_days).split('.')[0]
      );
      updatePriceDisplayContent(parent, finalPricing);
      let calories = parseDriedCalories(
        feeding.meal_cups_rounded,
        feeding.flavor_nutrition.density,
        feeding.flavor_nutrition.kcal_gram
      );
      bulkUpdateDisplayHtml(
        parent.querySelectorAll('[data-content="selected-variant-size"]'),
        feeding.meal_cups_html
      );
      bulkUpdateDisplayHtml(
        parent.querySelectorAll('[data-content="variant-calories-serving"]'),
        calories.per_meal.toFixed(0)
      );
      bulkUpdateDisplayHtml(
        parent.querySelectorAll('[data-content="variant-calories-day"]'),
        calories.per_day.toFixed(0)
      );
    } else {
      updatePriceDisplayContent(parent, priceList);
    }
    let sizeIndex = optionTitles.indexOf('size');
    let flavorIndex = optionTitles.indexOf('flavor');
    if (sizeIndex !== -1) {
      const sizeDisplays = parent.querySelectorAll(
        '[data-content="selected-variant-bag-size"]'
      );
      if (sizeDisplays.length > 0) {
        bulkUpdateDisplayContent(
          sizeDisplays,
          selectedVariant.options[sizeIndex].split('(')[1].replaceAll(')', '')
        );
      }
    }
    if (flavorIndex !== -1) {
      const flavorDisplays = parent.querySelectorAll(
        '[data-content="flavor-display"]'
      );
      if (flavorDisplays.length > 0) {
        bulkUpdateDisplayContent(
          flavorDisplays,
          selectedVariant.options[flavorIndex].replace(' and ', ' & ')
        );
      }
    }

    const variantImageDisplay = document.querySelector(
      '[data-content="variant-image"]'
    );
    if (variantImageDisplay) {
      let variantImage = parseImageSrc(
        selectedVariant.featured_image.src,
        '_160x160'
      );
      variantImageDisplay.src = variantImage;
    }
  }

  function parseDriedCalories(cups, density, perGram) {
    return {
      per_meal: cups * density * perGram,
      per_day: cups * density * perGram * 2
    };
  }

  function getSelectedVariant() {
    let selectedValues = {
      0: [],
      1: [],
      2: []
    };
    let values = parseVariantValues();
    values.forEach((value) => {
      let index = value.getAttribute('data-option-index');
      selectedValues[index].push(value.value);
    });
    return lookupVariantId(selectedValues);
  }

  function updateFormVariantId(variantJson) {
    if (!variantJson) return;

    let productId = variantJson.featured_image
      ? variantJson.featured_image.product_id
      : parseInt(
          document
            .querySelector('[data-product-id]')
            .getAttribute('data-product-id')
        );
    if (!productId) return;

    const productForm = document.querySelector(
      `[data-content="product-form"][data-form-product="${productId}"]`
    );
    if (!productForm) return;

    productForm.setAttribute('data-current-variant', variantJson.id);
    updateUrlVariantId(variantJson.id);
  }

  function updateUrlVariantId(variantId) {
    const currentURL = window.location.href;
    if (currentURL.includes('variant=')) {
      const newURL = currentURL.replace(/(variant=)(\d+)/, `$1${variantId}`);
      history.replaceState(null, null, newURL);
    } else {
      const separator = currentURL.includes('?') ? '&' : '?';
      const newURL = `${currentURL}${separator}variant=${variantId}`;
      history.replaceState(null, null, newURL);
    }
  }

  function parseVariantValues() {
    let selected = [];
    let selectedRadios = document.querySelectorAll(
      '[data-input-event="variant-option"]:checked'
    );
    selectedRadios.forEach((option) => {
      selected.push(option);
    });
    let selectedSelects = document.querySelectorAll(
      'select[data-input-event="variant-option"]'
    );
    selectedSelects.forEach((option) => {
      selected.push(option);
    });
    return selected;
  }

  function lookupVariantId(lookup) {
    return variantData.find((item) => {
      const checkOption = (option, key) => {
        if (lookup[key].length === 1) {
          // exact match, case insensitive
          return (
            option && option.toLowerCase() === lookup[key][0].toLowerCase()
          );
        } else {
          // includes all values from lookup
          return lookup[key].every(
            (val) => option && option.toLowerCase().includes(val.toLowerCase())
          );
        }
      };
      const option1Matches = checkOption(item.option1, '0');
      const option2Matches = checkOption(item.option2, '1');
      const option3Matches = checkOption(item.option3, '2');

      return option1Matches && option2Matches && option3Matches;
    });
  }

  function parseOptionPricing(selected, parent) {
    const fifteenFixedIds = ['6969058656302', '6969056002094', '6969058623534'];
    let basePrice = selected.price * 0.01;
    let quantityInput = parent.querySelector(
      '[data-content="variant-quantity"]'
    );
    let quantity = quantityInput ? parseInt(quantityInput.value) : 1;
    let subscriptionSelected = checkSubscription(parent);
    let variantPrices = {
      one_time: {
        unit_price: basePrice,
        full_price: parseRound(basePrice * quantity)
      }
    };

    const form = parent.closest('[data-content="product-form"]');
    const staticDiscount = form.hasAttribute('data-static-sub-rate');

    let activeOt;
    if (offer) {
      let offerData = parseOfferDetails(offer);
      let pairedOfferData;
      if (offerData.paired_offer) {
        pairedOfferData = parseOfferDetails(offerData.paired_offer);
      }
      if (offerData.apply_one_time === true) {
        activeOt = offerData;
        variantPrices.one_time.offer_price = parseRound(
          basePrice * offerData.discount * quantity
        );
      } else if (pairedOfferData && pairedOfferData.apply_one_time === true) {
        activeOt = pairedOfferData;
        variantPrices.one_time.offer_price = parseRound(
          basePrice * pairedOfferData.discount * quantity
        );
      }
    }
    let serving = parseUnitType(parent);
    if (serving.unit === 'grams' && serving.type === 'preset') {
      // FRESH PATH
      let divisible = variantPrices.one_time.offer_price || basePrice;
      if (activeOt) {
        variantPrices.one_time.per_meal = parseRound(
          (divisible / 14) * activeOt.discount
        );
        variantPrices.one_time.per_day = parseRound(
          (divisible / 7) * activeOt.discount
        );
      } else {
        variantPrices.one_time.per_meal = parseRound(divisible / 14);
        variantPrices.one_time.per_day = parseRound(divisible / 7);
      }
    }
    const autoshipSelectEl = parent.querySelector(
      'select[data-content="shipment-frequency"]'
    );
    const sellingPlanChecked = parent.querySelector(
      '[data-content="autoship-toggle"]:checked'
    );
    let sellingPlanValue = sellingPlanChecked ? sellingPlanChecked.value : null;
    if (subscriptionSelected && autoshipSelectEl) {
      let frequencyValue = parseFrequency(autoshipSelectEl.value);
      let discountRate = fifteenFixedIds.includes(
        parent.getAttribute('data-form-product')
      )
        ? 0.85
        : staticDiscount
          ? 1
          : parseFrequencyDiscount(frequencyValue);
      let recurringPrice = basePrice * discountRate;
      let autoshipPricing = {
        unit_price: parseRound(recurringPrice * quantity)
      };
      if (serving.unit === 'grams' && serving.type === 'preset') {
        // FRESH PATH
        autoshipPricing.per_meal = parseRound(recurringPrice / 14);
        autoshipPricing.per_day = parseRound(recurringPrice / 7);
      }
      if (offer) {
        let offerData = parseOfferDetails(offer);
        if (!offerData.apply_ss) {
          if (
            offerData.paired_offer &&
            parseOfferDetails(offerData.paired_offer).apply_ss
          ) {
            offerData = parseOfferDetails(offerData.paired_offer);
          } else {
            return;
          }
        }
        autoshipPricing.intro_price = parseRound(
          basePrice * offerData.discount * quantity
        );
        // if (offerData.apply_ss === true) {
        //     autoshipPricing.intro_price = parseRound((basePrice * offerData.discount) * quantity)
        // }
      }
      variantPrices.autoship = autoshipPricing;
    } else if (sellingPlanValue) {
      //console.log('sp value found!')
    }
    return variantPrices;
  }

  function updateFreshDisplayContent(priceList, selectedVariant) {
    // TO DO: Replace document with form for modular functionality
    updatePriceDisplayContent(document, priceList);
    let sizeIndex = optionTitles.indexOf('size');
    let flavorIndex = optionTitles.indexOf('flavor');
    if (sizeIndex !== -1) {
      bulkUpdateDisplayContent(
        document.querySelectorAll('[data-content="selected-variant-size"]'),
        selectedVariant.options[sizeIndex]
      );
      let variantSize = parseGramSizeInt(selectedVariant.options[sizeIndex]);
      let calorieData = getVariantCalories(selectedVariant, variantSize);
      bulkUpdateDisplayContent(
        document.querySelectorAll('[data-content="variant-calories-serving"]'),
        calorieData.selected.toFixed(0)
      );
      bulkUpdateDisplayContent(
        document.querySelectorAll('[data-content="variant-calories-day"]'),
        (calorieData.selected * 2).toFixed(0)
      );
      calorieData.flavors.forEach((flavor) => {
        bulkUpdateDisplayContent(
          document.querySelectorAll(
            `[data-content="variant-calories-serving--${flavor.title}"]`
          ),
          flavor.calories.toFixed(0)
        );
      });
      updateSizeOptions(selectedVariant.id, calorieData.sizes);
    }
    if (flavorIndex !== null) {
      bulkUpdateDisplayContent(
        document.querySelectorAll('[data-content="flavor-display"]'),
        selectedVariant.options[flavorIndex].replace(' and ', ' & ')
      );
    }
    let variantImage = parseImageSrc(
      selectedVariant.featured_image.src,
      '_160x160'
    );
    document.querySelector('[data-content="variant-image"]').src = variantImage;
  }

  function updateSizeOptions(variantId, nutrition) {
    const form = document.querySelector(
      `[data-content="product-form"][data-current-variant="${variantId}"]`
    );
    const flavorOptions = form.querySelectorAll(
      '[data-input-event="variant-option"][data-option-name="flavor"]'
    );
    const selectedFlavorOptions = Array.from(flavorOptions).some(
      (option) => option.checked
    );
    const sizeSelect = form.querySelector(
      '[data-input-event="variant-option"][data-option-name="portion"]'
    );
    const selectOptions = sizeSelect.querySelectorAll('option');
    selectOptions.forEach((option) => {
      const matched = nutrition.find((size) => size.title === option.value);
      option.textContent = selectedFlavorOptions
        ? `${option.value} (${matched.calories.toFixed(0)} calories per serving)`
        : option.value;
    });
  }

  function getVariantCalories(variant, size) {
    const nutrition = getVariantNutrition(variant.id);
    let form = document.querySelector(
      `[data-content="product-form"][data-current-variant="${variant.id}"]`
    );
    let serving = parseUnitType(form);
    if (serving.unit === 'grams' && serving.type === 'preset') {
      // FRESH PATH
      const flavors = variantNutrition
        .filter(
          (flavor) =>
            flavor.size === nutrition.size && !flavor.flavor.includes(' and ')
        )
        .map(({ flavor, size, kcal_gram }) => ({
          title: flavor.toLowerCase(),
          calories: parseGramSizeInt(size) * kcal_gram
        }));
      const sizes = variantNutrition
        .filter((flavor) => flavor.flavor === nutrition.flavor)
        .map(({ size, kcal_gram }) => ({
          title: size.toLowerCase(),
          calories: parseOzSizeInt(size) * kcal_gram
        }));
      return {
        type: serving.type,
        selected: nutrition.kcal_gram * size,
        flavors: flavors,
        sizes: sizes
      };
    } else {
      return null;
    }
  }

  /* ------------------------------------------------------------------------------------------------

    Frequency Change Options

    ------------------------------------------------------------------------------------------------  */

  function initFrequencyControls() {
    let frequencySelect = document.querySelector(
      '[data-content="shipment-frequency"]'
    );
    let dogSizeSelects = document.querySelectorAll(
      '[data-input-event="dog-size-options"]'
    );
    if (dogSizeSelects.length > 0) {
      dogSizeSelects.forEach((select) => {
        select.addEventListener('change', handleSizeFrequency);
      });
    }
    if (frequencySelect) {
      frequencySelect.addEventListener('change', handleFrequencyChange);
    }
    let autoshipCheckboxes = document.querySelectorAll(
      '[data-content="autoship-toggle"]'
    );
    if (autoshipCheckboxes.length > 0) {
      autoshipCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', handleFrequencyChange);
      });
    }
  }

  function handleSizeFrequency() {
    const sizeFrequencyLookup = {
      s: '12',
      m: '6',
      l: '4',
      xl: '3'
    };
    const form = this.closest('[data-content="product-form"]');
    const select = form.querySelector('[data-content="shipment-frequency"]');
    if (this.value !== 'manual') {
      select.disabled = true;
      select.value = sizeFrequencyLookup[this.value];
    } else {
      select.disabled = false;
    }
    select.dispatchEvent(new Event('change'));
  }

  function handleFrequencyChange() {
    let form = this.closest('[data-content="product-form"]');
    if (
      !this.getAttribute('data-content') ||
      this.getAttribute('data-content') !== 'autoship-toggle'
    ) {
      let frequency;
      if (this.value) {
        frequency = parseFrequency(this.value);
      } else {
        frequency = parseFrequency(
          document.querySelector('[data-content="shipment-frequency"]').value
        );
      }
      let serving = parseUnitType(form);
      if (serving.unit === 'grams' && serving.type === 'preset') {
        // FRESH PATH
        document.querySelector('[data-content="variant-quantity"]').value =
          frequency;
      }
      updateFrequencyOfferDisplay(frequency);
    }

    handleVariantChange();
  }

  function updateFrequencyOfferDisplay(value) {
    const fifteenFixedIds = ['6969058656302', '6969056002094', '6969058623534'];

    let target = document.querySelector(
      '[data-content="frequency-display-badge"]'
    );
    let slash = document.querySelector(
      '[data-content-type="one-time-compare"]'
    );
    let autoshipDisplay = document.querySelector(
      '[data-content-type="recurring-price"]'
    );

    const form = document.querySelector('[data-content="product-form"]');
    const staticDiscount = form.hasAttribute('data-static-sub-rate');

    let discount = fifteenFixedIds.includes(
      form.getAttribute('data-form-product')
    )
      ? 0.85
      : staticDiscount
        ? 1
        : parseFrequencyDiscount(value);

    let qtyInput = document.querySelector('[data-content="variant-quantity"]');

    let frequencyValueText = spelledNumbers[value];
    let quantityValueText = qtyInput
      ? spelledNumbers[parseInt(qtyInput.value)]
      : spelledNumbers[1];
    if (discount === 1) {
      if (target) {
        hide(target);
      }
      if (slash) {
        hide(slash);
      }
      if (autoshipDisplay) {
        autoshipDisplay.classList.remove('color-button');
      }
    } else {
      const discountDisplay = target
        ? target.querySelector('[data-content="frequency-discount"]')
        : null;
      if (discountDisplay) {
        discountDisplay.textContent = parseRound((1 - discount) * 100);
      }
      if (target) {
        unhide(target);
      }
      if (slash) {
        unhide(slash);
      }
      if (autoshipDisplay) {
        autoshipDisplay.classList.add('color-button');
      }
    }
    bulkUpdateDisplayContent(
      document.querySelectorAll('[data-content="quantity-text"]'),
      quantityValueText
    );
    bulkUpdateDisplayContent(
      document.querySelectorAll('[data-content="frequency-text"]'),
      frequencyValueText
    );
    if (quantityValueText == 'One') {
      bulkHide(
        document.querySelectorAll('[data-content="quantity-pluralize"]')
      );
    } else {
      bulkUnhide(
        document.querySelectorAll('[data-content="quantity-pluralize"]')
      );
    }
    if (frequencyValueText == 'One') {
      bulkHide(
        document.querySelectorAll('[data-content="frequency-pluralize"]')
      );
    } else {
      bulkUnhide(
        document.querySelectorAll('[data-content="frequency-pluralize"]')
      );
    }
  }

  /* ------------------------------------------------------------------------------------------------

    Quantity Change Options

    ------------------------------------------------------------------------------------------------  */

  function initQuantityControls() {
    let quantityInput = document.querySelector(
      '[data-content="variant-quantity"]'
    );
    let quantityModifiers = document.querySelectorAll(
      '[data-content="quantity-toggle"]'
    );
    if (quantityInput) {
      quantityInput.addEventListener('change', handleQuantityChange);
    }
    quantityModifiers.forEach((button) => {
      button.addEventListener('click', handleQuantityChange);
    });
  }

  function handleQuantityChange() {
    let currentQuantity = document.querySelector(
      '[data-content="variant-quantity"]'
    ).value;
    let value;
    let valueText = spelledNumbers[parseInt(currentQuantity)];
    if (valueText) {
      value = valueText;
    } else {
      value = currentQuantity;
    }
    //updateFrequencySelection(currentQuantity)
    handleVariantChange();
    bulkUpdateDisplayContent(
      document.querySelectorAll('[data-content="quantity-text"]'),
      value
    );
    if (currentQuantity == '1') {
      bulkHide(
        document.querySelectorAll('[data-content="quantity-pluralize"]')
      );
      bulkHide(
        document.querySelectorAll('[data-content="frequency-pluralize"]')
      );
    } else {
      bulkUnhide(
        document.querySelectorAll('[data-content="quantity-pluralize"]')
      );
      bulkUnhide(
        document.querySelectorAll('[data-content="frequency-pluralize"]')
      );
    }
  }

  // function updateFrequencySelection(value) {
  //     if (parseInt(value) <= 6) {
  //         let stringValue = `${value} Week`
  //         if (value !== '1') {
  //             stringValue += 's'
  //         }
  //         let frequencySelector = document.querySelector('[data-content="shipment-frequency"]')
  //         frequencySelector.value = stringValue
  //     }
  // }

  /* ------------------------------------------------------------------------------------------------

    Add Pet Functionality

    ------------------------------------------------------------------------------------------------  */

  function initPetAddTriggers() {
    let addPetTriggers = document.querySelectorAll(
      '[data-action="add-new-dog"]'
    );
    addPetTriggers.forEach((button) => {
      button.addEventListener('click', showPetAdd);
    });
  }

  function showPetAdd() {
    // Piggybacks existing drawer functionality
    showDrawer();
    addBtn.click();
  }

  function petAdded() {
    resetPetListeners();
    spliceNewPetOption(localStorage.getItem('selectedPet'));
    setPetListeners();
    selectCurrentPet();
  }

  function petDeleted() {
    const pets = getPets();
    const petMap = new Map(pets.map((pet, index) => [pet.id, index]));
    const selectedPetId = localStorage.getItem('selectedPet');
    document
      .querySelectorAll('[data-content="dog-select"]')
      .forEach((petElement) => {
        const petId = petElement.getAttribute('data-dog-id');
        const petIndex = petMap.get(petId);
        if (typeof petIndex !== 'undefined') {
          if (petElement.type && petElement.type === 'radio') {
            petElement.id = `form-dog-${petIndex}`;
          } else {
            petElement.setAttribute('for', `form-dog-${petIndex}`);
          }
        } else {
          petElement.remove();
          if (petId === selectedPetId) {
            localStorage.removeItem('selectedPet');
          }
        }
      });
    resetPetListeners();
    setPetListeners();
  }

  /* ------------------------------------------------------------------------------------------------

    Existing Pet Edited Functionality

    ------------------------------------------------------------------------------------------------  */

  function handlePetEdits() {
    handlePetSelection();
  }

  /* ------------------------------------------------------------------------------------------------

    Add To Cart

    ------------------------------------------------------------------------------------------------  */

  function initCartAddListeners() {
    let cartAdds = document.querySelectorAll('[data-action="cart-add"]');
    cartAdds.forEach((button) => {
      button.addEventListener('click', addItemToCart);
    });
  }

  function parseAddPayload(payload) {
    const supSelectedSize = document.querySelector(
      '[name="dog-size-options"]:checked'
    );
    if (
      payload.selling_plan &&
      supSelectedSize &&
      supSelectedSize.value !== 'manual'
    ) {
      payload.properties._default_supp_id = payload.selling_plan;
      payload.properties._default_supp_frequency =
        payload.properties._subscription_frequency;
      return payload;
    }
    return payload;
  }

  function addItemToCart() {
    this.classList.add('btn--loading');
    this.disabled = true;
    let form = this.closest('[data-content="product-form"]');
    let button = this;
    let payload = parseAddPayload(
      JSON.parse(form.querySelector('[data-for="cart-add"]').value)
    );

    const productId = form.getAttribute('data-form-product');
    if (productId === '4612542464046' || productId === '7042281439278') {
      if (payload.properties) {
        payload.properties['_unique_id'] = Date.now().toString();
      } else {
        payload.properties = {
          _unique_id: Date.now().toString()
        };
      }
    }

    fetch(theme.routes.cartAdd, {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      method: 'POST'
    })
      .then(function (response) {
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: form.getAttribute('data-form-product'),
              addToCartBtn: button
            }
          })
        );
        return response.json();
      })
      .catch(function (err) {
        /* uh oh, we have error. */
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: err.description
            }
          })
        );
        console.error(err);
      });
    this.classList.remove('btn--loading');
    this.disabled = false;
  }

  /* ------------------------------------------------------------------------------------------------

    Event Listeners

    ------------------------------------------------------------------------------------------------  */

  document.addEventListener('DOMContentLoaded', interactiveInit);
  document.addEventListener('petSelection:clear', clearPetSelection);
  document.addEventListener('petSelection:selected', handlePetSelection);
  document.addEventListener('petSelection:add', petAdded);
  document.addEventListener('petSelection:delete', petDeleted);
  document.addEventListener('petSelection:edit', handlePetEdits);

  function handleFfdFrequencyCustomization(variant) {
    const planSelector = document.querySelector(
      `select[data-content="shipment-frequency"]`
    );
    if (!planSelector) return;

    const defaultFrequencyId =
      variant.option3 && variant.option3.includes('6 Bags') ? '4' : '2';

    planSelector.value = defaultFrequencyId;

    let form = planSelector.closest('[data-content="product-form"]');
    updateFormAddContent(form, variant.id);
  }
}
